import { PayloadAction } from "@reduxjs/toolkit";
import { UpsellState } from "../../models/UpsellsState";
import { UpdateUpsellPayload } from "../../payload/UpdateUpsell/UpdateUpsellPayload";

const updateAdditionalFetch = (state: UpsellState, action: PayloadAction<UpdateUpsellPayload>) => {
    state.isLoading = true;
}

export default updateAdditionalFetch;